import { render, staticRenderFns } from "./chat.container.vue?vue&type=template&id=66e5fc1b&scoped=true&"
import script from "./chat.container.vue?vue&type=script&lang=js&"
export * from "./chat.container.vue?vue&type=script&lang=js&"
import style0 from "./chat.container.vue?vue&type=style&index=0&id=66e5fc1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5fc1b",
  null
  
)

export default component.exports